// Components
import { Button } from 'components/Button';
import * as Modal from 'components/Modal';

type DeleteConfirmationModalProps = {
  modalTrigger: React.ReactNode;
  onDelete: () => void;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  isPending?: boolean;
};

export const DeleteConfirmationModal: React.FC<
  DeleteConfirmationModalProps
> = ({ modalTrigger, onDelete, isOpen, onOpenChange, isPending }) => {
  return (
    <Modal.TriggerRoot isOpen={isOpen} onOpenChange={onOpenChange}>
      {modalTrigger}
      <Modal.Overlay>
        <Modal.Root className="max-w-120">
          <Modal.Dialog>
            <h3 className="mb-8 text-center text-xl text-gray-600">
              Jeste li sigurni da želite obrisati ovaj zapis? Ova radnja je
              nepovratna.
            </h3>
            <div className="flex gap-4">
              <Button
                colorScheme="tertiary"
                className="flex-1"
                onPress={onDelete}
                isPending={isPending}
              >
                Obriši
              </Button>
              <Button
                colorScheme="secondary"
                variant="outline"
                slot="close"
                className="flex-1"
              >
                Odustani
              </Button>
            </div>
          </Modal.Dialog>
        </Modal.Root>
      </Modal.Overlay>
    </Modal.TriggerRoot>
  );
};
